// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_fixedContainer__WY0Mf {
  height: 3rem; }

.styles_header__Vo5TE {
  height: 3rem;
  padding: 0rem 0.5rem;
  box-shadow: 0px 7px 5px #8080802e, 0px -3px 5px #8888885c;
  width: -web-kit-fill-available;
  width: 100%;
  background-color: #fff;
  z-index: 3; }
  .styles_header__Vo5TE h2 {
    margin: unset;
    font-size: 18px;
    margin-left: 0.9rem; }
  .styles_header__Vo5TE .styles_title__oPWiZ {
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/layout/Header/styles.module.scss","webpack://./src/modules/Core/styles/mixins.scss"],"names":[],"mappings":"AAIA;EACE,YAFW,EAAA;;AAKb;EACE,YANW;EAOX,oBAAoB;EACpB,yDAEwB;EACxB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,UAAU,EAAA;EATZ;IAWI,aAAa;IACb,eAAe;IACf,mBAAmB,EAAA;EAbvB;ICME,qBDW0B;ICV1B,4BAA4B;IAC5B,gBAAgB;IAChB,oBAAoB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n@import \"src/modules/Core/styles/mixins.scss\";\n\n$height: 3rem;\n.fixedContainer {\n  height: $height;\n}\n\n.header {\n  height: $height;\n  padding: 0rem 0.5rem;\n  box-shadow:\n    0px 7px 5px $grey18,\n    0px -3px 5px #8888885c;\n  width: -web-kit-fill-available;\n  width: 100%;\n  background-color: #fff;\n  z-index: 3;\n  h2 {\n    margin: unset;\n    font-size: 18px;\n    margin-left: 0.9rem;\n  }\n\n  .title {\n    @include multilineText(2);\n  }\n}\n","// @import \"src/modules/Core/styles/mixins.scss\";\n@mixin respond-to($breakpoint) {\n  @media (max-width: $breakpoint) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin multilineText($lines){\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: -webkit-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fixedContainer": `styles_fixedContainer__WY0Mf`,
	"header": `styles_header__Vo5TE`,
	"title": `styles_title__oPWiZ`
};
export default ___CSS_LOADER_EXPORT___;
